module.exports = __webpack_public_path__ + "static/media/card-image-abcpublica.ecbb202a.jpg";